import Entries from "./Entries";

export default Entries;
